const defaultData = {
  info: {},
  permissionTags: [],
  roleTags: [],
  roles: [],
  modules: {},
  menus: [],
  theme: 'default'
}
const user = localStorage.user ? JSON.parse(localStorage.user) : defaultData
export default {
  namespaced: true,
  state: user,
  mutations: {
    setUserInfo(state, data) {
      state.info = { ...state.info, ...data }
      this.commit('main/user/updateCache')
    },
    setUserRoles(state, data) {
      state.roles = [...state.roles, ...data]
      this.commit('main/user/updateCache')
    },
    setUserModules(state, data) {
      state.modules = data
      this.commit('main/user/updateCache')
    },
    setUserMenus(state, data) {
      state.menus = data
      this.commit('main/user/updateCache')
    },
    setUserPermissionTags(state, data) {
      state.permissionTags = data
      this.commit('main/user/updateCache')
    },
    setUserRoleTags(state, data) {
      state.roleTags = [...state.roleTags, ...data]
      this.commit('main/user/updateCache')
    },
    setUserTheme(state, data) {
      state.theme = data
      this.commit('main/user/updateCache')
    },
    updateCache(state) {
      localStorage.user = JSON.stringify(state)
    },
    clear(state) {
      state = { ...state, ...defaultData }
      // localStorage.removeItem('user')
      localStorage.clear()
    }
  }
}
